import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SocketService } from '../../services/socket.service';
import { NotificationsService } from '../../services/notifications.service';

import { cloneDeep, forEach, orderBy, has } from 'lodash';

import { SocketResponse } from '../../services/socket.service';
import { Notification } from '../../modals/notification';
import { AuthService } from '../../pages/auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-topbar-notifications',
  templateUrl: './topbar-notifications.component.html',
  styleUrls: ['./topbar-notifications.component.scss'],
  standalone: false,
})
export class TopbarNotificationsComponent implements OnInit {
  notificationsData = null;
  moment = require('moment');

  constructor(
    private socketService: SocketService,
    private notificationsService: NotificationsService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.subscribeAuthData().subscribe((authData) => {
      if (has(authData, 'days_left') && authData.days_left > 0) {
        this.getNotifications();

        this.socketService.subscribe('notification_push', (socketData: SocketResponse) => {
          this.checkNotificationStatus(socketData);
        });

        this.socketService.subscribe('notifications_reload', (socketData: SocketResponse) => {
          this.notificationsData = socketData.data;
        });
      }
    });
  }

  private getNotifications() {
    this.notificationsService.getNotifications().subscribe(
      (response) => {
        this.notificationsData = response['data'];
      },
      (error) => {}
    );
  }

  private checkNotificationStatus(socketData: SocketResponse) {
    let notification = socketData.data;

    if (notification.status) {
      this.removeNotification(notification);
    } else {
      this.addNotification(notification);
    }
  }

  private addNotification(notification: Notification) {
    let priorityKey = notification.notification_type.priority === 1 ? 'critical' : 'other';
    let notificationDate = this.moment(notification.create_date).format('YYYY-MM-DD');
    let intervalIndex;
    let isExistNotification = false;

    forEach(this.notificationsData[priorityKey].grouped_notifications, (interval, index) => {
      if (interval.date === notificationDate) {
        intervalIndex = index;
      }

      forEach(interval.notifications, (n) => {
        if (n.id === notification.id) {
          isExistNotification = true;
        }
      });
    });

    if (!isExistNotification) {
      if (typeof intervalIndex !== 'undefined' && intervalIndex > -1) {
        this.notificationsData[priorityKey].grouped_notifications[intervalIndex].notifications.push(notification);
        this.notificationsData[priorityKey].grouped_notifications[intervalIndex].notifications = orderBy(
          this.notificationsData[priorityKey].grouped_notifications[intervalIndex].notifications,
          ['create_date'],
          ['desc']
        );
      } else {
        this.notificationsData[priorityKey].grouped_notifications.push({
          date: notificationDate,
          notifications: [notification],
        });
        this.notificationsData[priorityKey].grouped_notifications = orderBy(this.notificationsData[priorityKey].grouped_notifications, ['date'], ['desc']);
      }

      this.notificationsData[priorityKey].grouped_notifications = cloneDeep(this.notificationsData[priorityKey].grouped_notifications);
    }
  }

  private removeNotification(notification: Notification) {
    let priorityKey = notification.notification_type.priority === 1 ? 'critical' : 'other';
    let notificationDate = this.moment(notification.create_date).format('YYYY-MM-DD');
    let intervalIndex, notificationIndex;

    forEach(this.notificationsData[priorityKey].grouped_notifications, (interval, index) => {
      if (interval.date === notificationDate) {
        intervalIndex = index;

        forEach(interval.notifications, (n, notIndex) => {
          if (n.id === notification.id) {
            notificationIndex = notIndex;
          }
        });
      }
    });

    if (typeof intervalIndex !== 'undefined' && intervalIndex > -1 && typeof notificationIndex !== 'undefined' && notificationIndex > -1) {
      this.notificationsData[priorityKey].grouped_notifications[intervalIndex].notifications.splice(notificationIndex, 1);
      this.notificationsData[priorityKey].count = this.notificationsData[priorityKey].count - 1;
    }

    this.notificationsData[priorityKey].grouped_notifications = cloneDeep(this.notificationsData[priorityKey].grouped_notifications);
  }
}
